import { useNavigate } from "react-router-dom";

import { Technician } from "../../types/user";
import { mapRoleDisplay } from "../../utils/mapRoleDisplay";
import { LoadingSpinner } from "../LoadingSpinner/LoadingSpinner";
import { NoData } from "../NoData/NoData";

import styles from "./user-list-component.module.css";
import UsersCard from "./UsersCard";

interface UserListComponentProps {
  users: Technician[];
  loading: boolean;
  page: number;
  backgroundColor?: string;
  deactivated?: boolean;
  customerAdmin?: boolean;
}

const UserListComponent: React.FC<UserListComponentProps> = ({
  users,
  loading,
  page,
  backgroundColor,
  deactivated,
  customerAdmin,
}) => {
  const navigate = useNavigate();
  const handleCardClick = (user: Technician) => {
    const id = user?.user?.id ?? user?.id;
    navigate("/add-user", {
      state: {
        ...user,
        id,
        email: user.email ?? user.loginName,
        roles: user.roles?.map((role) => mapRoleDisplay(role)) || [],
        role: mapRoleDisplay(user.roles?.[0] ?? ""),
        documents: user.documents || [],
        deactivated,
        customerAdmin
      },
    });
  };
  return (
    <div className={styles["list"]}>
      {!loading && users.length === 0 && (
        <NoData>Keine Benutzer vorhanden.</NoData>
      )}

      {users.length > 0 &&
        users.map((user, index) => (
          <UsersCard
            key={user.id || index}
            user={{
              firstName: user.firstName ?? "",
              lastName: user.lastName ?? "",
              email: user.email ?? user.loginName,
              roles: user.roles,
              lastLoginDate: user.lastLoginDate ?? "",
            }}
            onClick={() => handleCardClick(user)}
            color={backgroundColor ?? undefined}
          />
        ))}
      {loading && page > 1 && (
        <LoadingSpinner loading={loading} size={20} top="0" />
      )}
    </div>
  );
};

export default UserListComponent;
